// The blob is a sample (e.g. 250k dots) of the much larger England + Wales
// population. The dots on the map render the raw sample, but every people-count
// we surface in text (build badge, filter stages, KPIs, chart axes, status
// line) should be scaled up to the real population so the numbers feel honest
// at a glance.
//
// Source: ONS Census 2021, Table TS001 (usual residents). The total below is
// the sum of `population_count` across all LSOAs in
// data/boundaries/population_counts.csv, which is the same file that seeds the
// `region` table in the database. If that CSV is regenerated, regenerate this
// constant too (sum the column or read it from the loader logs).
export const ENGLAND_AND_WALES_POPULATION = 59_597_601;

export function getScaleFactor(sampleSize: number): number {
  if (!sampleSize || sampleSize <= 0) return 1;
  return ENGLAND_AND_WALES_POPULATION / sampleSize;
}

export function scaleCount(rawCount: number, sampleSize: number): number {
  if (!rawCount) return 0;
  return Math.round(rawCount * getScaleFactor(sampleSize));
}

export function formatScaledCount(rawCount: number, sampleSize: number): string {
  return scaleCount(rawCount, sampleSize).toLocaleString();
}
